import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})

export class ExtTaxaAdmService {

    constructor(private http: HttpClient){}

    public Listar(anomesInicio, anomesFim): Observable<any>{
        return this.http
                   .get(`${environment.apiURL}/Logado/Extratos/ExtTaxaAdm/Listar`,{params:{anomesInicio: anomesInicio, anomesFim: anomesFim}})
    }

    public AnoMes(): Observable<any>{
      return this.http
                 .get(`${environment.apiURL}/Logado/Extratos/ExtTaxaAdm/AnoMes`)
    }

}